// extracted by mini-css-extract-plugin
export default {"cell":"EditCellRender_cell__RRlFQ","editCell":"EditCellRender_editCell__vnZCs"};